<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MLdG3A/tc-custom/9780061976926.jpg?1731794526735" alt="This image is the cover for the book History on a Personal Note"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History on a Personal Note
      </h1>
      <p class="bookDescription body article font2">
        <p>From New York City to the former East Germany, from rural Virginia to affluent suburbia, the characters in these short stories grapple with love, loss, greed, perversion, and other awful truths as they try to transcend their limitations with occasional humor and dignity. In "History on a Personal Note," Lorraine, a Southerner, wonders if her German paramour will find the inspiration to leave his wife amidst the destruction of the Berlin Wall. In "Viewing Stacy from Above," a pregnant woman descends into a pit of despair as she contemplates the constraints of motherhood. In "Money Honey," a young adulteress who ditches her husband is reprimanded by an extended family of elders whose morals are even more dubious than her own.</p><p>Contemplative, allegorical, and witty, <i>History on a Personal Note</i> takes us into a world laced with black humor and makes us laugh -- until it hurts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Binnie Kirshenbaum
      </h2>
      
      <p class="authorDescription body article"><P>Binnie Kirshenbaum is the author of <I>An Almost Perfect Moment, On Mermaid Avenue, A Disturbance in One Place, Pure Poetry, Hester Among the Ruins,</I> and <I>History on a Personal Note.</I> She is a professor at Columbia University's School of the Arts, where she is chair of the Graduate Writing Program.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?027fd7d9